var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.time > 0)?_c('div',{staticClass:"time-range"},[_c('p',{staticClass:"time-block"},[_c('span',{staticClass:"range-start"},[_vm._v("距离开始")]),_c('span',{staticClass:"range-text-span"},[_c('span',{staticClass:"range-text"},[_vm._v("还有")]),_c('span',{staticClass:"range-time-text"},[_vm._v(_vm._s(_vm.timeRange))])])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }